<template>
  <FormGroup
    :error="error"
    :errorMessage="errorMessage"
  >
    <template v-slot="params">
      <r-textarea
        :label="label"
        :value="value || ''"
        :rows="rows"
        :error="error"
        @input="$emit('input', $event)"
        :readonly="readonly"
      />
    </template>
    <template v-slot:after>
      <slot name="after"></slot>
    </template>
  </FormGroup>
</template>

<script>
  import FormGroup from "@/components/FormGroup.vue";

  export default {
    name: 'FormInput',
    components: {
      FormGroup,
    },
    props: {
      label: {
        type: String,
        default: null,
      },
      value: {
        type: [String, Number],
      },
      readonly: {
        type: Boolean,
        default: false,
      },
      error: {
        type: Boolean,
        default: false, 
      },
      errorMessage: {
        type: String,
        default: ''
      },
      rows: {
        type: Number,
        default: 5
      }
    },
  }
</script>
